// Generated by purs version 0.15.0
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Services_Storage from "../Restaumatic.Services.Storage/index.js";
import * as Restaumatic_Services_Storage_LocalStorageWithFallback from "../Restaumatic.Services.Storage.LocalStorageWithFallback/index.js";
var fodClaimedKey = "claimedFod";
var getFodStatus = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect)(/* #__PURE__ */ Data_Maybe.fromMaybe(false))(/* #__PURE__ */ Restaumatic_Services_Storage.getJSONItem(Foreign_Generic_Class.booleanDecode)(Restaumatic_Services_Storage_LocalStorageWithFallback.localStorageWithFallback)(fodClaimedKey));
var resetFodState = /* #__PURE__ */ Restaumatic_Services_Storage.setJSONItem(Foreign_Generic_Class.booleanEncode)(Restaumatic_Services_Storage_LocalStorageWithFallback.localStorageWithFallback)(fodClaimedKey)(false);
export {
    fodClaimedKey,
    resetFodState,
    getFodStatus
};
//# sourceMappingURL=index.js.map
